module.exports = __webpack_public_path__ + "img/battery_color2.457f9055.png";